import React from 'react'
import { DateRangePicker } from 'rsuite';
import 'rsuite/DatePicker/styles/index.css';
import 'rsuite/dist/rsuite.min.css';


function DateRangeFilterPicker({ value, onChange, ...props }) {

 
    
    return (

        <div className='input-pad'>
                <DateRangePicker
                // showOneCalendar
                  format="MMM dd, yyyy"
                  placeholder="Select Date Range"
                  className='w-100'
                  value={value}
                  onChange={onChange}
                  appearance="subtle"
                  editable={false}
                  responsive={true}
                  {...props}
                /> 
        </div>
    )
}

export default DateRangeFilterPicker
